var _templateObject, _templateObject2, _templateObject3;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import { number, arrayOf, oneOf } from 'prop-types';
import styled from 'styled-components';
import tokens from '@gympass/yoga-tokens';
import { media } from '@gympass/yoga-helpers';
var breakpoints = tokens.breakpoints;

var columnPosition = function columnPosition(props) {
  var breakpointKeys = Object.keys(breakpoints);
  var position = breakpointKeys.filter(function (breakpoint) {
    return props[breakpoint];
  }).map(function (filteredBreakpoint) {
    return media[filteredBreakpoint](_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n        grid-column-end: span ", ";\n      "])), props[filteredBreakpoint] || 12);
  });
  var starts = breakpointKeys.filter(function (breakpoint) {
    return props[breakpoint + "-start"];
  }).map(function (start) {
    return media[start](_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n        grid-column-start: ", ";\n      "])), props[start + "-start"]);
  });
  return [].concat(position, starts);
};

var hideColumn = function hideColumn(hideProp) {
  return hideProp.map(function (breakpoint) {
    return media.hide[breakpoint];
  });
};

var Col = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  box-sizing: border-box;\n\n  min-width: 0;\n  min-height: 0;\n\n  ", "\n\n  ", "\n"])), function (props) {
  return columnPosition(props);
}, function (_ref) {
  var hide = _ref.hide;
  return hide ? hideColumn(hide) : '';
});
Col.propTypes = {
  hide: arrayOf(oneOf(['xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl', 'xxxl'])),
  xxs: number,
  xs: number,
  sm: number,
  md: number,
  lg: number,
  xl: number,
  xxl: number,
  xxxl: number,
  'xxs-start': number,
  'xs-start': number,
  'sm-start': number,
  'md-start': number,
  'lg-start': number,
  'xl-start': number,
  'xxl-start': number,
  'xxxl-start': number
};
Col.defaultProps = {
  hide: undefined,
  xxs: undefined,
  xs: undefined,
  sm: undefined,
  md: undefined,
  lg: undefined,
  xl: undefined,
  xxl: undefined,
  xxxl: undefined,
  'xxs-start': undefined,
  'xs-start': undefined,
  'sm-start': undefined,
  'md-start': undefined,
  'lg-start': undefined,
  'xl-start': undefined,
  'xxl-start': undefined,
  'xxxl-start': undefined
};
export default Col;